// Defines the root react uri:
export default '/react/';
